"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userController = void 0;
const endpoints_1 = require("../../../constants/endpoints");
const typescriptHacks_1 = require("../../../helper/typescriptHacks");
const apiPath = endpoints_1.endpoints.user;
const userController = (service) => ({
    readAll: () => {
        return service.get(apiPath, service.addAccessTokenToHeaders);
    },
    readAllAdmin: (item) => __awaiter(void 0, void 0, void 0, function* () {
        const apiResult = yield service.post(apiPath, item, service.addAccessTokenToHeaders);
        return apiResult.value;
    }),
    update: (item) => {
        return service.put(apiPath, item, service.addAccessTokenToHeaders);
    },
    markAsAdmin: (guid) => {
        return service.put(`${apiPath}/${guid}`, typescriptHacks_1.anyObject, service.addAccessTokenToHeaders);
    },
    del: (guid) => {
        const url = `${apiPath}/${guid}`;
        return service.delete(url, service.addAccessTokenToHeaders);
    }
});
exports.userController = userController;
